import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { withPrefix } from 'gatsby';
import React from 'react';

const StyledLogo = styled.picture`
  ${({ theme: { media } }) => css`
    img {
      width: 180px;
      height: auto;

      @media (min-width: ${media.medium}) {
        width: 220px;
      }
    }
  `};
`;

export const Logo = () => {
  const { media } = useTheme();
  const mobile1x = withPrefix('/logo/logo-tdi-kelliher-180.png');
  const mobile2x = withPrefix('/logo/logo-tdi-kelliher-360.png');
  const desktop1x = withPrefix('/logo/logo-tdi-kelliher-220.png');
  const desktop2x = withPrefix('/logo/logo-tdi-kelliher-440.png');

  return (
    <StyledLogo>
      <source
        media={`(min-width: ${media.medium})`}
        srcSet={`${desktop1x} 1x, ${desktop2x} 2x`}
      />
      <img
        src={mobile1x}
        srcSet={`${mobile1x} 1x, ${mobile2x} 2x`}
        alt="Trade Direct Insurance. Part of Kelliher Insurance Group"
        width={220}
        height={58}
        loading="eager"
        // Workaround React 18 not properly supporting fetchPriority on img tags
        {...{ fetchpriority: 'high' }}
      />
    </StyledLogo>
  );
};

export default Logo;
